import ApiNode from "./ApiNode";

export default {
  // Base list
  getList(params = {}) {
    return ApiNode().get("ledger-outstanding-master", { params });
  },

  // Year-wise list
  getByYear(year, params = {}) {
    return ApiNode().get(`ledger-outstanding-master/year/${year}`, { params });
  },

  // Monthly variants
  getClientWiseMonthly(params = {}) {
    return ApiNode().get("ledger-outstanding-master/client-wise-month", {
      params,
    });
  },

  getAgentWiseMonthly(params = {}) {
    return ApiNode().get("ledger-outstanding-master/agent-wise-month", {
      params,
    });
  },

  getShippingLineWiseMonthly(params = {}) {
    return ApiNode().get("ledger-outstanding-master/shipping-line-wise-month", {
      params,
    });
  },

  getBranchWiseMonthly(params = {}) {
    return ApiNode().get("ledger-outstanding-master/branch-wise-month", {
      params,
    });
  },

  // Export to Excel
  exportToExcel(params = {}) {
    return ApiNode().get("ledger-outstanding-master/export", {
      params,
      responseType: "blob",
    });
  },

  // High-level dashboard summary (cards)
  getDashboardSummary(params = {}) {
    return ApiNode().get("ledger-outstanding-master/dashboard-summary", {
      params,
    });
  },

  // Monthly data for charts / time series
  getDashboardMonthly(params = {}) {
    return ApiNode().get("ledger-outstanding-master/dashboard-monthly", {
      params,
    });
  },

  // Data update logs (created / updated counts by date)
  getDataUpdates(params = {}) {
    return ApiNode().get("ledger-outstanding-master/get-data-updates", {
      params,
    });
  },

  // Assignments
  getAssignments(params = {}) {
    return ApiNode().get("ledger-outstanding-master/assignments", { params });
  },

  // Client-wise aggregates
  getClientWise(params = {}) {
    return ApiNode().get("ledger-outstanding-master/client-wise", { params });
  },

  // Client-branch-wise aggregates
  getClientBranchWise(params = {}) {
    return ApiNode().get("ledger-outstanding-master/client-branch-wise", {
      params,
    });
  },

  // Client-wise with pending days buckets
  getClientWisePendingDays(params = {}) {
    return ApiNode().get("ledger-outstanding-master/client-wise-pending-days", {
      params,
    });
  },

  // Client, Agent, Consignee wise with pending days buckets (All Aging)
  getClientAgentConsigneeWisePendingDays(params = {}) {
    return ApiNode().get(
      "ledger-outstanding-master/client-agent-consignee-wise-pending-days",
      { params },
    );
  },

  // Agent-wise aggregates
  getAgentWise(params = {}) {
    return ApiNode().get("ledger-outstanding-master/agent-wise", { params });
  },

  // Agent-branch-wise aggregates
  getAgentBranchWise(params = {}) {
    return ApiNode().get("ledger-outstanding-master/agent-branch-wise", {
      params,
    });
  },

  // Shipping line-wise aggregates
  getShippingLineWise(params = {}) {
    return ApiNode().get("ledger-outstanding-master/shipping-line-wise", {
      params,
    });
  },

  // Shipping line + branch-wise
  getShippingLineBranchWise(params = {}) {
    return ApiNode().get(
      "ledger-outstanding-master/shipping-line-branch-wise",
      { params },
    );
  },

  // Branch-wise aggregates
  getBranchWise(params = {}) {
    return ApiNode().get("ledger-outstanding-master/branch-wise", { params });
  },

  // Branch-client-wise
  getBranchClientWise(params = {}) {
    return ApiNode().get("ledger-outstanding-master/branch-client-wise", {
      params,
    });
  },

  // Branch-agent-wise
  getBranchAgentWise(params = {}) {
    return ApiNode().get("ledger-outstanding-master/branch-agent-wise", {
      params,
    });
  },

  // Branch-shipping-line-wise
  getBranchShippingLineWise(params = {}) {
    return ApiNode().get(
      "ledger-outstanding-master/branch-shipping-line-wise",
      { params },
    );
  },

  // Bulk Import
  importLedgerOutstanding(payload) {
    return ApiNode().post("ledger-outstanding-master/import", payload);
  },
};



// WEBPACK FOOTER //
// ./src/services/LedgerOutstandingDashboardService.js